import { createAction } from '@reduxjs/toolkit';
export const UPDATE_MESSAGE_SESSION_STATUS = 'UPDATE_MESSAGE_SESSION_STATUS';
export const updateMessageSessionStatusAction = createAction(UPDATE_MESSAGE_SESSION_STATUS, (messageSessionId, status) => ({
  payload: { messageSessionId, status }
}));

export const UPDATE_MESSAGE_SESSION_NOTIFICATION = 'UPDATE_MESSAGE_SESSION_NOTIFICATION';
export const updateMessageSessionNotificationAction = createAction(
  UPDATE_MESSAGE_SESSION_NOTIFICATION,
  (messageSessionId, muted) => ({
    payload: { messageSessionId, muted }
  })
);